/** Session type min length, hard coded */
const MIN_LENGTH = 5;

/**
 * Check if the session has valid length
 * @param value session length value
 */
export default function isValidSessionLength(
  value: string | number | undefined,
) {
  return value === undefined || value === ""
    ? true
    : (value || 0) >= MIN_LENGTH;
}
